import { ClipboardList, FileWarning, PhoneCall } from 'lucide-react';

const PROBLEMS = [
  {
    icon: ClipboardList,
    title: 'State boards audit deliveries.',
    body: 'When a pharmacy compliance officer asks for proof a delivery happened correctly, most pharmacies hand over a screenshot of a text message and a photo from a driver\'s personal phone.',
  },
  {
    icon: FileWarning,
    title: 'HIPAA requires evidence.',
    body: 'Pharmacies are responsible for delivery accountability under HIPAA\'s chain-of-custody requirements, but most have no system that survives an audit.',
  },
  {
    icon: PhoneCall,
    title: 'Patients call about missed deliveries.',
    body: 'When a patient says "I never got my medication," pharmacies spend hours reconstructing the delivery from phone calls, driver memory, and missing photos.',
  },
] as const;

export function Problem() {
  return (
    <section className="border-y border-border bg-bg-soft py-24 md:py-32">
      <div className="container-page">
        <div className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-wider text-primary">The problem</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink md:text-4xl">
            Pharmacies are responsible for delivery accountability — and most have no system of record.
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {PROBLEMS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-2xl border border-border bg-white p-6 shadow-sm"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-soft text-primary">
                <Icon className="h-4 w-4" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 text-base font-semibold text-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-2">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
